import { setMarqueDetailsData, resetMarqueDetailsData } from '../../../redux/marqueDetailsDataSlice';
import { SuccessfullModifyDialog } from '../../SuccessfullModifyDialog';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import MarqueDetailsContent from './marqueDetailsContent';
import { useCallback, useEffect, useState } from 'react';
import MarqueDetailsHeader from './marqueDetailsHeader';
import { Box, CircularProgress } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import axios from 'axios';

const MarqueDetails = () => {

    const { id } = useParams();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);

    const fetchMarqueDetails = useCallback(async () => {
        try {
            const { data, status } = await axios.get(`marque/${id}`);
            if ((status === 200 || status === 201) && data) {
                dispatch(setMarqueDetailsData(data));
                setLoading(false);
            } else {
                setLoading(false);
                console.warn('Unexpected response status or empty data:', status, data);
            }
        } catch (error) {
            setLoading(false);
            console.error('Erreur lors de la récupération des informations de marque :', error);
            CustomErrorLogger(error, 'Erreur dans fetchMarqueDetails');
        }
    }, [id, dispatch]);

    // Scroll to top on mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Fetch marque details on mount and cleanup on unmount
    useEffect(() => {
        fetchMarqueDetails();
        return () => {
            dispatch(resetMarqueDetailsData());
        };
    }, [fetchMarqueDetails, dispatch]);

    return (
        <Box>
            {loading ?
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '80vh',
                    }}
                >
                    <CircularProgress
                        sx={{
                            '& .MuiCircularProgress-circle': { stroke: '#EA5E00' },
                        }}
                    />
                </Box>
                :
                <Box>
                    <MarqueDetailsHeader />
                    <MarqueDetailsContent />
                    <SuccessfullModifyDialog />
                </Box>
            }
        </Box>
    );
}

export default MarqueDetails;